var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { useResizeObserver } from '@react-aria/utils';
import { Children, isValidElement, useCallback, useEffect, useRef, useState, } from 'react';
import { ToggleButtonProvider } from './context';
import DropdownToggle from './dropdown';
import { buttonWrapperStyle, wrapperStaticStyle } from './styles';
function ToggleButtonInternal(_a) {
    var { activeItem, children, fullWidth = false, hideDividers = false, onChange, size = 'medium', variant = 'primary' } = _a, restProps = __rest(_a, ["activeItem", "children", "fullWidth", "hideDividers", "onChange", "size", "variant"]);
    const wrapperRef = useRef(null);
    const buttonWrapperRef = useRef(null);
    const [isOverflowing, setIsOverflowing] = useState(false);
    const [measuredMinWidth, setMeasuredMinWidth] = useState(0);
    const hasDividers = !hideDividers;
    const childrenIsArray = Array.isArray(children);
    const childArray = childrenIsArray ? Children.toArray(children) : [];
    const isDropdown = childrenIsArray && isOverflowing;
    const handleOverflow = useCallback(() => {
        if (wrapperRef.current == null) {
            return;
        }
        if (!fullWidth) {
            setIsOverflowing(wrapperRef.current.scrollWidth < measuredMinWidth ||
                wrapperRef.current.clientWidth < wrapperRef.current.scrollWidth);
        }
        else if (buttonWrapperRef.current != null) {
            const newIsOverflowing = wrapperRef.current.scrollWidth < measuredMinWidth ||
                wrapperRef.current.clientWidth < buttonWrapperRef.current.scrollWidth;
            // Set our base measuredWidth to be minimum width that the content overflows when fullWidth
            if (newIsOverflowing && measuredMinWidth === 0) {
                setMeasuredMinWidth(buttonWrapperRef.current.scrollWidth);
            }
            setIsOverflowing(newIsOverflowing);
        }
    }, [measuredMinWidth, wrapperRef, fullWidth]);
    useResizeObserver({
        onResize: handleOverflow,
        ref: fullWidth ? buttonWrapperRef : wrapperRef,
    });
    useEffect(() => {
        if (buttonWrapperRef.current != null && !fullWidth) {
            setMeasuredMinWidth(buttonWrapperRef.current.scrollWidth);
        }
    }, [fullWidth]);
    return (_jsx(ToggleButtonProvider, Object.assign({}, Object.assign({ activeItem,
        fullWidth,
        hasDividers,
        isDropdown,
        onChange,
        size,
        variant }, (childrenIsArray &&
        activeItem === '' &&
        isValidElement(childArray[0]) && {
        firstButtonId: childArray[0].props.id,
    })), { children: _jsx("div", Object.assign({ css: wrapperStaticStyle, ref: wrapperRef }, { children: _jsx("div", Object.assign({ css: buttonWrapperStyle({
                    fullWidth,
                    hasDividers,
                }), ref: buttonWrapperRef }, restProps, (!isDropdown && { role: 'list' }), { children: isDropdown ? (_jsx(DropdownToggle, { children: childArray })) : (children) })) })) })));
}
export default ToggleButtonInternal;
